var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"ma-1",attrs:{"color":"blue-grey","dark":"","x-small":""},on:{"click":function($event){return _vm.$emit('click')}}},[_c('v-icon',{attrs:{"small":""}},[_vm._v("mdi-undo")]),_vm._v(" Hoàn tác ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }